/**
 * Visual-only profanity filter — nothing is ever blocked, rejected, or
 * replaced at the source. Words travel as-is; viewers who opt in (default
 * ON) see them censored at render time: first letter kept, rest asterisked
 * ("fucking" → "f******"). Includes light leet normalization (0→o, 4→a, …).
 */
const CENSOR_WORDS = [
  "fuck",
  "fucker",
  "fucking",
  "motherfucker",
  "shit",
  "bitch",
  "bastard",
  "cunt",
  "twat",
  "dick",
  "cock",
  "pussy",
  "nigger",
  "nigga",
  "faggot",
  "fag",
  "whore",
  "slut",
  "asshole",
] as const;

/** Character → leet lookalikes allowed in a matched word. */
function leetVariants(ch: string): string {
  switch (ch) {
    case "o":
      return "0";
    case "i":
      return "1l";
    case "l":
      return "1";
    case "e":
      return "3";
    case "a":
      return "4@";
    case "s":
      return "5$";
    case "t":
      return "7";
    case "g":
      return "6";
    case "b":
      return "8";
    default:
      return "";
  }
}

function wordPattern(word: string): string {
  const body = word
    .split("")
    .map((c) => `[${c}${leetVariants(c)}]`)
    .join("");
  return `\\b${body}\\b`;
}

const PATTERNS = CENSOR_WORDS.map((w) => new RegExp(wordPattern(w), "gi"));

export function censorText(input: string): string {
  let out = input;
  for (const re of PATTERNS) {
    out = out.replace(re, (m) => m[0] + "*".repeat(m.length - 1));
  }
  return out;
}
